import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const Onboarding = ({ onSetupComplete }) => {
  const { t, i18n } = useTranslation();
  const [config, setConfig] = useState({ centerName: '', centerAddress: '', centerPhone: '', centerWebsite: '', centerLogoUrl: '', pharmacyName: '', laboratoryName: '', plan: 'simple', aiName: '', centerType: '', userRole: 'Administrateur', billingCode: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setConfig(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!config.centerName || !config.centerType) return;
    if (['Caisse', 'Pharmacie'].includes(config.userRole) && !config.billingCode) {
      alert('Veuillez renseigner le code d\'accès facturation pour ce rôle.');
      return;
    }
    const cfg = { ...config, aiName: config.aiName || 'Assistant' };
    onSetupComplete(cfg);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  // ... (les styles restent les mêmes)
  const styles = {
    container: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column', backgroundColor: '#f0f2f5' },
    card: { padding: '40px', borderRadius: '10px', boxShadow: '0 10px 25px rgba(0,0,0,0.1)', backgroundColor: 'white', textAlign: 'center', maxWidth: '400px' },
    title: { marginBottom: '10px' },
    subtitle: { marginBottom: '30px', color: '#666' },
    form: { display: 'flex', flexDirection: 'column', gap: '15px' },
    input: { padding: '10px', borderRadius: '5px', border: '1px solid #ccc' },
    button: { padding: '10px 20px', border: 'none', borderRadius: '5px', backgroundColor: '#007bff', color: 'white', cursor: 'pointer' },
    langSelector: { marginTop: '20px', borderTop: '1px solid #eee', paddingTop: '20px' }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>{t('welcome_title')}</h1>
        <p style={styles.subtitle}>{t('setup_subtitle')}</p>
        <form onSubmit={handleSubmit} style={styles.form}>
          <label htmlFor="centerType">Mode d'utilisation :</label>
          <select id="centerType" name="centerType" value={config.centerType} onChange={handleChange} style={styles.input} required>
            <option value="">Veuillez choisir...</option>
            <option value="personal">Usage Personnel</option>
            <option value="clinic">Clinique</option>
            <option value="hospital">Centre Hospitalier</option>
            <option value="health_center_bed">Centre de Santé (avec lit)</option>
            <option value="health_center_no_bed">Centre de Santé (sans lit)</option>
          </select>

          <label htmlFor="userRole">Rôle utilisateur :</label>
          <select id="userRole" name="userRole" value={config.userRole} onChange={handleChange} style={styles.input} required>
            <option value="Administrateur">Administrateur</option>
            <option value="Caisse">Caisse</option>
            <option value="Pharmacie">Pharmacie</option>
            <option value="Médecin">Médecin</option>
            <option value="Infirmier">Infirmier</option>
            <option value="Secrétaire">Secrétaire</option>
          </select>

          {['Caisse', 'Pharmacie'].includes(config.userRole) && (
            <>
              <label htmlFor="billingCode">Code d'accès facturation</label>
              <input id="billingCode" name="billingCode" type="text" value={config.billingCode} onChange={handleChange} placeholder="Entrez le code d'accès" style={styles.input} required />
            </>
          )}

          <label htmlFor="centerName">Nom de l'utilisateur ou de l'établissement</label>
          <input id="centerName" name="centerName" type="text" value={config.centerName} onChange={handleChange} placeholder="Entrez votre nom ou le nom de votre clinique" style={styles.input} required />

          <label htmlFor="centerAddress">Adresse du centre</label>
          <input id="centerAddress" name="centerAddress" type="text" value={config.centerAddress} onChange={handleChange} placeholder="Adresse du centre" style={styles.input} />

          <label htmlFor="centerPhone">Téléphone du centre</label>
          <input id="centerPhone" name="centerPhone" type="text" value={config.centerPhone} onChange={handleChange} placeholder="Téléphone du centre" style={styles.input} />

          <label htmlFor="centerWebsite">Site web / email</label>
          <input id="centerWebsite" name="centerWebsite" type="text" value={config.centerWebsite} onChange={handleChange} placeholder="Site web ou email" style={styles.input} />

          <label htmlFor="centerLogoUrl">URL du logo</label>
          <input id="centerLogoUrl" name="centerLogoUrl" type="text" value={config.centerLogoUrl} onChange={handleChange} placeholder="https://..." style={styles.input} />

          <label htmlFor="pharmacyName">Nom de la pharmacie</label>
          <input id="pharmacyName" name="pharmacyName" type="text" value={config.pharmacyName} onChange={handleChange} placeholder="Nom spécifique de la pharmacie" style={styles.input} />

          <label htmlFor="laboratoryName">Nom du laboratoire</label>
          <input id="laboratoryName" name="laboratoryName" type="text" value={config.laboratoryName} onChange={handleChange} placeholder="Nom spécifique du laboratoire" style={styles.input} />

          <label htmlFor="plan">Plan d'abonnement</label>
          <select id="plan" name="plan" value={config.plan} onChange={handleChange} style={styles.input}>
            <option value="simple">Simple (gratuit)</option>
            <option value="pro">Pro</option>
            <option value="enterprise">Enterprise</option>
          </select>

          <label htmlFor="aiName">{t('ai_name_label')}</label>
          <input id="aiName" name="aiName" type="text" value={config.aiName} onChange={handleChange} placeholder={t('ai_name_placeholder')} style={styles.input} />
          
          <button type="submit" style={styles.button}>{t('start_button')}</button>
        </form>
        <div style={styles.langSelector}>
            <button onClick={() => changeLanguage('fr')}>Français</button> | <button onClick={() => changeLanguage('en')}>English</button>
        </div>
      </div>
    </div>
  );
};

export default Onboarding;
